
// Venue names and ticketmaster venue ids

const venues = [
	{ name: 'All Venues', value: 'default' },
	{ name: 'The Axis Club', value: 'KovZpZAFlF1A' },
	{ name: 'Baby G', value: 'KovZ917AqfB' },
	{ name: 'Budweiser Stage', value: 'KovZpZAEkkIA' },
	{ name: 'Coca-Cola Coliseum', value: 'KovZpZAJt7FA' },
	{ name: 'Dakota Tavern', value: 'KovZpZAadAJA' },
	{ name: 'Danforth Music Hall', value: 'KovZpa3yBe' },
	{ name: 'Drake Underground', value: 'KovZpZAJd17A' },
	{ name: 'History', value: 'KovZ917AJ4f' },
	{ name: 'Horseshoe Tavern', value: 'KovZpZAdt7JA' },
	{ name: 'The Garrison', value: 'KovZpZAdtAeA' },
	{ name: 'Lee\'s Palace', value: 'KovZpZAdIFJA' },
	{ name: 'Longboat Hall', value: 'KovZ917ALcm' },
	{ name: 'Massey Hall', value: 'KovZpZAFnlnA' },
	{ name: 'Monarch Tavern', value: 'KovZpZAadnaAs' },
	{ name: 'The Opera House', value: 'KovZpZAFlvvA' },
	{ name: 'Phoenix Concert Theatre', value: 'KovZpZAFFEEA' },
	{ name: 'Queen Elizabeth Theatre', value: 'KovZpZAdIFtA' },
	{ name: 'Radio(Adelaide Hall)', value: 'KovZpZAJe7FA' },
	{ name: 'RBC Echo Beach', value: 'KovZpZAJ6EFA' },
	{ name: 'Rebel Nightclub', value: 'KovZpZAdIFaA' },
	{ name: 'Rec Room', value: 'KovZ917ALUf' },
	{ name: 'The Rivoli', value: 'KovZpZAFlvdA' },
	{ name: 'Roy Thomson Hall', value: 'KovZpZAFl6JA' },
	{ name: 'Scotiabank Arena', value: 'KovZpZAFFE1A' },
	{ name: 'Sony Centre', value: 'KovZpZAFFEJA' },
	{ name: 'TOYBOX(Union Nightclub)', value: 'KovZpZAEe1EA' },
	{ name: 'Velvet Underground', value: 'KovZpZAFlFAA' },
];

export default venues;
